<ng-container *ngIf="hasData; else emptySeries">
  <po-info
    *ngIf="weekly"
    p-label="Agrupado"
    [p-value]="groupingNote"
    p-orientation="horizontal">
  </po-info>

  <po-chart
    [p-type]="columnType"
    [p-categories]="categories"
    [p-series]="series"
    [p-options]="chartOptions"
    [p-height]="300">
  </po-chart>
</ng-container>

<ng-template #emptySeries>
  <p class="po-font-text-small">Nenhum review neste período.</p>
</ng-template>
